import { TreatName, treatInfo } from '@marketing/content';
var allTreatsProductCardData = {};
Object.keys(treatInfo).forEach(function (key) {
    allTreatsProductCardData[key] = {
        productDetails: {
            productName: treatInfo[key].displayName,
            price: treatInfo[key].price,
            productId: treatInfo[key].productId,
            isActive: treatInfo[key].isActive,
            ingredients: treatInfo[key].ingredients,
            pageUrl: treatInfo[key].url,
        },
        isNew: treatInfo[key].isNew,
        imageData: treatInfo[key].image,
    };
});
export var treatsProductListingContent = {
    title: 'Our Enriching Treats',
    productCardData: [
        allTreatsProductCardData[TreatName.BeefJerky],
        allTreatsProductCardData[TreatName.ChickenJerky],
        allTreatsProductCardData[TreatName.SweetPotato],
        allTreatsProductCardData[TreatName.BeefBlueberry],
        allTreatsProductCardData[TreatName.ChickenCranberry],
    ],
};
